/* ==================================================
  c_web-limited-cart-add-guard.js — 客注モードで購入制限（Web限定）SKU をカートに追加させない
  spec: 03_客注モード_FE §2.6.5（6 導線）。判定は window.CWebLimited（c_web-limited.js）。

  3 つの層で止める。いずれも客注モード（スタッフトークンあり）のときだけ動き、通常の EC は素通し。
    1. 表示: form[is=product-form] の「カートに追加」ボタンを選択中 SKU で判定して非活性化する。
       バリエーション選択つきの購入ボタン（#AddToCart / #StickyAddToCart 等）は文言も「Web限定」にする
       （売り切れ表示と同じ扱い）。簡易カード・Shop the Look などのボタンは非活性化のみ。
       在庫切れの SKU（テーマが先にボタンを無効化して「売り切れ」にしている）は対象でも触らず、通常の EC と同じ表示にする。
    2. 送信: document の submit キャプチャで form[is=product-form] を止める（Enter キー等の抜け道）。
    3. 通信: POST /cart/add(.js|.json) を包む。商品詳細の SKU 行・AI Fit 診断チャット・Boost の
       クイック追加など、フォームを通らず自前で fetch する導線もここで止め、422 を返す
       （呼び出し側は既存の失敗表示を出す。新しいメッセージは出さない）。
       ページ上に判定データが無い SKU は、直前にクリックされたカードの商品ハンドルから
       /products/{handle}?view=web-limited を取得して判定する。それでも判定できなければ通す
       （チェックアウトの Cart & Checkout Validation Function が最終的に止める）。
  ===================================================*/
(function () {
  'use strict';

  if (window.CWebLimitedCartAddGuard) return;

  var DISABLED_CLASS = 'c_web-limited-disabled';
  var CONTEXT_TTL_MS = 10000;
  var ADD_PATH_RE = /\/cart\/add(?:\.js|\.json)?\/?$/;
  var ITEM_ID_KEY_RE = /^items\[\d+\]\[id\]$/;

  function api() {
    return window.CWebLimited || null;
  }

  function isStaff() {
    var W = api();
    return !!(W && W.isStaffMode());
  }

  function variantIdOf(form) {
    var input = form.querySelector('[name="id"]');
    return input && input.value ? input.value : null;
  }

  function isRestrictedIn(el, variantId) {
    var W = api();
    if (!W || variantId == null) return false;
    return W.isVariantRestricted(W.dataFor(el, variantId), variantId);
  }

  /* ---------- 1. 表示（ボタンの非活性化） ---------- */

  /* バリエーション選択つきの購入ボタン（文言を「Web限定」にする対象） */
  var RELABEL_SELECTOR = '[data-product-add-to-cart-button], #AddToCart, #StickyAddToCart';

  function buttonsOf(form) {
    var list = Array.prototype.slice.call(form.querySelectorAll('button[type="submit"]'));
    /* form.id は name="id" の input に隠れるため属性で読む（画面下部に追従する購入ボタンは form= で紐づく） */
    var formId = form.getAttribute('id');
    if (formId) {
      var outside = document.querySelectorAll('button[type="submit"][form="' + formId + '"]');
      for (var i = 0; i < outside.length; i++) {
        if (list.indexOf(outside[i]) === -1) list.push(outside[i]);
      }
    }
    return list;
  }

  /* 文言を差し替えるときは元の子ノードそのものを退避して戻す（loader-button などは
     自分の子ノードへの参照を持っているため、innerHTML で作り直すと壊れる）。 */
  function blockButton(btn) {
    if (btn.classList.contains(DISABLED_CLASS)) return;
    /* テーマが無効化済み = 選択中の SKU が在庫切れ（または存在しない組み合わせ）。「Web限定」にせずテーマの表示のままにする */
    if (btn.disabled) return;
    var state = { nodes: null, disabled: btn.disabled };
    btn.classList.add(DISABLED_CLASS);
    btn.disabled = true;
    btn.setAttribute('aria-disabled', 'true');
    if (btn.matches(RELABEL_SELECTOR)) {
      state.nodes = Array.prototype.slice.call(btn.childNodes);
      btn.textContent = api().labels().all;
    }
    btn.__cWebLimitedState = state;
  }

  function releaseButton(btn) {
    if (!btn.classList.contains(DISABLED_CLASS)) return;
    var state = btn.__cWebLimitedState || { nodes: null, disabled: false };
    btn.classList.remove(DISABLED_CLASS);
    if (state.nodes) {
      while (btn.firstChild) btn.removeChild(btn.firstChild);
      state.nodes.forEach(function (node) { btn.appendChild(node); });
    }
    btn.disabled = state.disabled;
    if (!state.disabled) btn.removeAttribute('aria-disabled');
    btn.__cWebLimitedState = null;
  }

  function applyForms() {
    if (!api()) return;
    var staff = isStaff();
    var forms = document.querySelectorAll('form[is="product-form"]');
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      var restricted = staff && isRestrictedIn(form, variantIdOf(form));
      var buttons = buttonsOf(form);
      for (var j = 0; j < buttons.length; j++) {
        if (restricted) blockButton(buttons[j]);
        else releaseButton(buttons[j]);
      }
    }
  }

  var applyTimer = null;
  function scheduleApply() {
    if (applyTimer) return;
    applyTimer = setTimeout(function () {
      applyTimer = null;
      applyForms();
    }, 50);
  }

  /* ---------- 2. 送信（submit キャプチャ） ---------- */

  function onSubmit(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[is="product-form"]')) return;
    if (!isStaff()) return;
    if (!isRestrictedIn(form, variantIdOf(form))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  /* ---------- 3. 通信（POST /cart/add の包み） ---------- */

  function isCartAddRequest(url, method) {
    if (String(method || 'GET').toUpperCase() !== 'POST') return false;
    try {
      var path = new URL(String(url), window.location.href).pathname;
      return ADD_PATH_RE.test(path);
    } catch (e) {
      return false;
    }
  }

  function idsFromParams(params) {
    var ids = [];
    params.forEach(function (value, key) {
      if (key === 'id' || ITEM_ID_KEY_RE.test(key)) ids.push(String(value));
    });
    return ids;
  }

  function idsFromJson(obj) {
    var ids = [];
    if (!obj || typeof obj !== 'object') return ids;
    if (obj.id != null) ids.push(String(obj.id));
    if (Array.isArray(obj.items)) {
      obj.items.forEach(function (item) {
        if (item && item.id != null) ids.push(String(item.id));
      });
    }
    return ids;
  }

  /* リクエスト本文からバリアント ID を取り出す。読めない本文は [] （= 通す）。 */
  function parseCartAddIds(body) {
    if (body == null) return [];
    if (typeof FormData !== 'undefined' && body instanceof FormData) return idsFromParams(body);
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return idsFromParams(body);
    if (typeof body === 'string') {
      var text = body.trim();
      if (text.charAt(0) === '{') {
        try { return idsFromJson(JSON.parse(text)); } catch (e) { return []; }
      }
      return idsFromParams(new URLSearchParams(text));
    }
    if (typeof body === 'object' && !(typeof Blob !== 'undefined' && body instanceof Blob)) return idsFromJson(body);
    return [];
  }

  function readIds(input, init) {
    if (init && init.body != null) return Promise.resolve(parseCartAddIds(init.body));
    if (typeof Request !== 'undefined' && input instanceof Request) {
      var type = input.headers.get('Content-Type') || '';
      var copy = input.clone();
      var read = /json/i.test(type)
        ? copy.text()
        : copy.formData().catch(function () { return input.clone().text(); });
      return read.then(parseCartAddIds, function () { return []; });
    }
    return Promise.resolve([]);
  }

  /* 直前のクリックの位置（AI Fit のカード・Boost のカードなど）から商品ハンドルの候補を拾う。 */
  var lastClick = { el: null, at: 0 };

  function handleHints() {
    var el = lastClick.el;
    if (!el || Date.now() - lastClick.at > CONTEXT_TTL_MS || !el.closest) return [];
    var hints = [];
    var aiFit = el.closest('.tabio-aifit__card');
    if (aiFit) {
      var sizeSelect = aiFit.querySelector('[data-size-select]');
      if (sizeSelect && sizeSelect.value) hints.push(sizeSelect.value);
      if (aiFit.getAttribute('data-handle')) hints.push(aiFit.getAttribute('data-handle'));
    }
    var boost = el.closest('[data-product]');
    if (boost) {
      try {
        var product = JSON.parse(boost.getAttribute('data-product'));
        if (product && product.handle) hints.push(String(product.handle));
      } catch (e) { /* 判定データの候補にしないだけ */ }
    }
    var generic = el.closest('[data-product-handle]');
    if (generic) hints.push(generic.getAttribute('data-product-handle'));
    return hints.filter(function (h, i) { return h && hints.indexOf(h) === i; });
  }

  var nativeFetch = typeof window.fetch === 'function' ? window.fetch : null;
  var byHandle = {};

  function rootUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return root || '/';
  }

  /* 商品ハンドルの判定データを取得して登録する（ハンドル単位で 1 回。失敗はキャッシュしない）。 */
  function loadHandle(handle) {
    if (byHandle[handle]) return byHandle[handle];
    var url = rootUrl() + 'products/' + encodeURIComponent(handle) + '?view=web-limited';
    var p = nativeFetch.call(window, url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (text) {
        var data = api().parse(text);
        if (!data) throw new Error('invalid web-limited data');
        api().register(data);
        return data;
      })
      .catch(function (err) {
        delete byHandle[handle];
        throw err;
      });
    byHandle[handle] = p;
    return p;
  }

  /* ids のうち 1 つでも購入制限対象なら true。判定データが見つからない ID は通す。 */
  function anyRestricted(ids, contextEl) {
    var W = api();
    var unknown = [];
    for (var i = 0; i < ids.length; i++) {
      var data = W.dataFor(contextEl, ids[i]);
      if (!data) unknown.push(ids[i]);
      else if (W.isVariantRestricted(data, ids[i])) return Promise.resolve(true);
    }
    if (!unknown.length) return Promise.resolve(false);
    var hints = handleHints();
    if (!hints.length) {
      console.warn('[c_web-limited-cart-add-guard] no web-limited data for variant(s)', unknown.join(','));
      return Promise.resolve(false);
    }
    return Promise.all(hints.map(function (h) {
      return loadHandle(h).catch(function () { return null; });
    })).then(function () {
      for (var k = 0; k < unknown.length; k++) {
        var found = W.lookup(unknown[k]);
        if (!found) {
          console.warn('[c_web-limited-cart-add-guard] no web-limited data for variant', unknown[k]);
          continue;
        }
        if (W.isVariantRestricted(found, unknown[k])) return true;
      }
      return false;
    });
  }

  function blockedResponse() {
    return new Response(JSON.stringify({ status: 422, message: '', description: '' }), {
      status: 422,
      headers: { 'Content-Type': 'application/json' }
    });
  }

  function installFetchGuard() {
    if (!nativeFetch) return;
    window.fetch = function (input, init) {
      var self = this;
      var args = arguments;
      var url = input && typeof input === 'object' && 'url' in input ? input.url : input;
      var method = (init && init.method) || (input && typeof input === 'object' && input.method) || 'GET';
      if (!api() || !isStaff() || !isCartAddRequest(url, method)) return nativeFetch.apply(self, args);
      var contextEl = lastClick.el;
      return readIds(input, init)
        .then(function (ids) { return ids.length ? anyRestricted(ids, contextEl) : false; })
        .catch(function () { return false; })
        .then(function (blocked) {
          return blocked ? blockedResponse() : nativeFetch.apply(self, args);
        });
    };
  }

  /* ---------- 初期化 ---------- */

  installFetchGuard();
  document.addEventListener('submit', onSubmit, true);
  document.addEventListener('click', function (event) {
    lastClick = { el: event.target, at: Date.now() };
  }, true);

  function init() {
    if (!isStaff()) return;
    applyForms();
    document.addEventListener('change', scheduleApply, true);
    document.addEventListener('variant:changed', scheduleApply, true);
    if (typeof MutationObserver === 'function' && document.body) {
      new MutationObserver(scheduleApply).observe(document.body, { childList: true, subtree: true });
    }
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) applyForms();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* テスト・調査用（状態は持たない関数だけ） */
  window.CWebLimitedCartAddGuard = {
    isCartAddRequest: isCartAddRequest,
    parseCartAddIds: parseCartAddIds,
    applyForms: applyForms
  };
})();
